export const FILTER_ALL = -1
export const FILTER_FAILED = 1
export const FILTER_SKIPPED = 2
